import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { btnLink } from 'src/app/shared/helpers/btn-link/btn-link.model';

/**
 * The hover dropdown under a main nav entry (בית מדרש / שאל את הרב / לוח שנה / ויקישיבה).
 *
 * The links are rendered here rather than through a template passed down from
 * sticky-header: emulated encapsulation tags an element with the attribute of the
 * component whose template created it, so a parent-declared ng-template rendered in
 * here would produce <a>/<span> that this stylesheet cannot select.
 *
 * The trigger stays in sticky-header and opens the panel through the inherited
 * --sub-links-max-height custom property, which does cross the component boundary.
 */
@Component({
    selector: 'header-sub-links',
    templateUrl: './header-sub-links.component.html',
    styleUrls: ['./header-sub-links.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class HeaderSubLinksComponent {
    links = input<btnLink[] | undefined>([]);
    isAngularApp = input(false);
}
